import { getTableForColumn } from "../../../components/MainContent/hooks/useTableColumnsConfig";
import { RELATED_TABLES } from "../index";

export const filterInfluencersByRelatedTables = async (supabase, filters) => {
  const parseNumericValue = (fieldValue) => {
    if (typeof fieldValue === "string" && fieldValue.includes("M")) {
      return parseFloat(fieldValue.replace("M", "")) * 1000000;
    } else if (typeof fieldValue === "string" && fieldValue.includes("K")) {
      return parseFloat(fieldValue.replace("K", "")) * 1000;
    } else {
      return parseFloat(fieldValue);
    }
  };
  
  try {
    const allInfluencersResult = await supabase.from("influencers").select("id");

    if (allInfluencersResult.error) {
      throw new Error(`Error fetching all influencers: ${allInfluencersResult.error.message}`);
    }
    const allIds = allInfluencersResult.data?.map((item) => item.id) || [];
    const filtersByTable = {};

    filters.forEach((filter) => {
      const tableName = getTableForColumn({ columnKey: filter.column });
      if (tableName && RELATED_TABLES.includes(tableName)) {
        if (!filtersByTable[tableName]) {
          filtersByTable[tableName] = [];
        }
        filtersByTable[tableName].push(filter);
      }
    });

    let filteredIds = allIds;

    for (const [tableName, tableFilters] of Object.entries(filtersByTable)) {
      if (tableFilters.length === 0) continue;
      const columns = ["influencer_id", ...tableFilters.map((f) => f.column)];
      const uniqueColumns = [...new Set(columns)];
      const tableResult = await supabase
        .from(tableName)
        .select(uniqueColumns.join(", "))
        .not("influencer_id", "is", null);
      if (tableResult.error) {
        throw new Error(`Error fetching data from ${tableName}: ${tableResult.error.message}`);
      }
      const tableData = tableResult.data || [];

      filteredIds = filteredIds.filter((id) => {
        const influencerData = tableData.find((item) => item.influencer_id === id);
        if (!influencerData) return false;

        return tableFilters.every((filter) => {
          const { column, operator, value } = filter;
          const fieldValue = influencerData[column];

          if (!fieldValue || fieldValue === "n/a" || fieldValue === null) {
            return false;
          }

          if (operator === "greater than") {
            const numericValue = parseNumericValue(fieldValue);
            const threshold = parseFloat(value);
            return !isNaN(numericValue) && !isNaN(threshold) && numericValue > threshold;
          }

          if (operator === "less than") {
            const numericValue = parseNumericValue(fieldValue);
            const threshold = parseFloat(value);
            return !isNaN(numericValue) && !isNaN(threshold) && numericValue < threshold;
          }

          if (operator === "equals") {
            return fieldValue == value;
          }
          if (operator === "does not equal") {
            return fieldValue != value;
          }
          if (operator === "contains") {
            return String(fieldValue).toLowerCase().includes(String(value).toLowerCase());
          }
          if (operator === "does not contain") {
            return !String(fieldValue).toLowerCase().includes(String(value).toLowerCase());
          }
          if (operator === "starts with") {
            return String(fieldValue).toLowerCase().startsWith(String(value).toLowerCase());
          }
          if (operator === "ends with") {
            return String(fieldValue).toLowerCase().endsWith(String(value).toLowerCase());
          }
          if (operator === "is any of") {
            const targetValues = String(value)
              .split(",")
              .map((v) => v.trim());
            return targetValues.includes(String(fieldValue));
          }

          return true;
        });
      });
    }
    return filteredIds;
  } catch (error) {
    console.error("Error in related tables filter:", error);
    return [];
  }
};
